import { Fragment } from "react";


function ReservationWhatToKnow() {
    return (
        <Fragment>
            <div className="reservation-title smaller-text">What to know before you go</div>
            <div className="smaller-text">A note from the restaurant</div>
            <div className="smaller-text">
                Thank you for choosing Simply Dumpling - Calgary
                (located on 101 9 Ave SW). Should your plans change, 
                please let us know.
            </div>                
        </Fragment>
    );
}


export default ReservationWhatToKnow;